export default __webpack_public_path__ + "static/media/website-icon-TYG.24a7fcc7.svg";